<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 13C7.55228 13 8 13.4477 8 14C8 14.5523 7.55228 15 7 15H6C5.44772 15 5 14.5523 5 14C5 13.4477 5.44772 13 6 13H7Z" fill="black"/>
    <path d="M16 13C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15H15C14.4477 15 14 14.5523 14 14C14 13.4477 14.4477 13 15 13H16Z" fill="black"/>
    <path d="M12 4C12.5523 4 13 4.44772 13 5C13 5.55228 12.5523 6 12 6H10C9.44771 6 9 5.55228 9 5C9 4.44772 9.44771 4 10 4H12Z" fill="black"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14 1C15.6569 1 17 2.34315 17 4V9C17 9.351 16.9369 9.68694 16.8262 10H18C19.6569 10 21 11.3431 21 13V18C21 19.6569 19.6569 21 18 21H13C12.2305 21 11.531 20.7077 11 20.2314C10.469 20.7077 9.76947 21 9 21H4C2.34315 21 1 19.6569 1 18V13C1 11.3431 2.34315 10 4 10H5.17383C5.06306 9.68694 5 9.351 5 9V4C5 2.34315 6.34315 1 8 1H14ZM4 12C3.44772 12 3 12.4477 3 13V18C3 18.5523 3.44772 19 4 19H9C9.55229 19 10 18.5523 10 18V13C10 12.4477 9.55228 12 9 12H4ZM13 12C12.4477 12 12 12.4477 12 13V18C12 18.5523 12.4477 19 13 19H18C18.5523 19 19 18.5523 19 18V13C19 12.4477 18.5523 12 18 12H13ZM8 3C7.44772 3 7 3.44772 7 4V9C7 9.55229 7.44772 10 8 10H14C14.5523 10 15 9.55228 15 9V4C15 3.44772 14.5523 3 14 3H8Z" fill="black"/>
  </svg>
</template>

<script>

export default {
  name: 'productIcon',
  components: {
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
